module.exports = __webpack_public_path__ + "img/havas-voyages.4be9d93f.jpeg";